module.exports = __webpack_public_path__ + "img/nase_hnutie.5e7b8c34.png";